import { httpClient2 } from "modules/core/utils/httpClient2";

import { UserFeatureModuleKey } from "../types/entities";
import { IFeatureModulesResponse } from "../types/res";

export const fetchFeatureModules = async () => {
  const response = await httpClient2.get<IFeatureModulesResponse>(
    "/feature_modules"
  );

  return response.data;
};

export const addAccountFeatureModule = async (key: UserFeatureModuleKey) => {
  const response = await httpClient2.post<IFeatureModulesResponse>(
    "/feature_module_accesses/add_module",
    undefined,
    {
      params: {
        key
      }
    }
  );

  return response.data;
};

export const deleteAccountFeatureModule = async (key: UserFeatureModuleKey) => {
  const response = await httpClient2.put<IFeatureModulesResponse>(
    "/feature_module_accesses/remove_module",
    undefined,
    {
      params: {
        key
      }
    }
  );

  return response.data;
};
